export const calendarDateFormat = "do MMM y";
export const calendarHourFormat = "H:mm";

export enum AvailabilityCategory {
  Event = "Event",
}
